<template>
  <section class="flex">
      <h1>
          Our Teachers
      </h1>
      <img  src="../../assets/underline.png" alt="">
      <h4>Our teachers have spent hours upon hours honing their skills. You can be sure they know how to really <br> make yoga classes interesting and engaging for your kids. </h4>
  </section>

<section>
    <div class="row">

<div class="container1">
    <div class="container1_1">
<img  src="../../assets/ourteacher1.png" alt="">
</div>
<div class="container1_2">
<h2>Nelofer Fernandes</h2>
<br>
<h4>A teacher first connects with the child and then <br> teaching just follows. A certified Montessori <br>
teacher, Nelofer is brilliant with children. <br>
She has been conducting story telling sessions <br>
across the globe for 2 years now.</h4>
</div>

</div>

<div class="container2">
    <div class="container1_1">
<h2>Chandni Pathak</h2>
<br>
<h4>A certified 200-hour yoga teacher who has <br> been teaching kids for over a year, Chandni <br>
believes that yoga is an important life skill that <br> every child should learn for a healthy and <br>
happy life.</h4>
</div>
<div class="conatiner1_2">


<img  src="../../assets/ourteacher2.png" alt="">
</div>

</div>

    </div>
</section>

</template>

<script>
export default {

}
</script>

<style scoped>
.container1{
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    flex-wrap: wrap;
}
.container2{
    display: flex;
    align-items: center;
    justify-content: space-evenly;
        flex-wrap: wrap-reverse;
}
.row{
        width: 50%;
    margin: auto;
    display: flex;
    flex-direction: column;
    padding-top: 70px;
}

.flex{
    display: flex;
    align-items: center;
    flex-direction: column;
    height: 239px;
    justify-content: space-evenly;
    text-align: center;
    margin-top: 100px;
    
}
h1{
    color: #791E94;
    font-weight: 500;
    font-family: 'Original Surfer', cursive;
    font-size: 3rem;
}
h4{
    color: #44526B;
    font-weight: 500;
    line-height: 150%;
}

@media (max-width: 1350px){
    .container1, .container2{
        height: 700px;
    }
}

</style>